import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { useMsal } from '@azure/msal-react';
import useSensorStore from '../store/sensorStore';
import { errorHandler } from '../utils/helpers';
import { msalConfig } from '../auth/authConfig';
import { acquireToken } from '../utils/auth';

interface FetchData {
  token: string | null;
  updateSensorBillableStatuses: (data: any) => any;
  setError: (data: any) => any;
  setLoading: (data: any) => any;
};

const fetchData = async ({
    token,
    updateSensorBillableStatuses,
    setError,
    setLoading,
  }: FetchData) => {
  try {
    const response = await axios.get(`${window.__env.REACT_APP_API_URL || process.env.REACT_APP_API_URL}/Sensor/BillableStatus`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json, text/plain, */*',
      },
    });
    const billableStatuses = response.data;
    updateSensorBillableStatuses(billableStatuses);
  } catch (error) {
    errorHandler(error, setError);
  } finally {
    setLoading(false);
  }
};

interface SensorBillableStatuses {
  fetchSensorBillableStatuses: () => void;
  loading: boolean;
  error: Error | null;
};

const useFetchSensorBillableStatuses = (): SensorBillableStatuses => {
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const { updateSensorBillableStatuses } = useSensorStore();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchSensorBillableStatuses = async () => {
    if (accounts.length > 0) {
      const accessTokenRequest = {
        scopes: [`${msalConfig.auth.clientId}/.default`],
        account: accounts[0],
      };
      try {
        const accessToken = await acquireToken(instance, accessTokenRequest);
        fetchData({
          token: accessToken,
          updateSensorBillableStatuses,
          setError,
          setLoading,
        });
      } catch (error) {
        errorHandler(error, setError);
      }
    } else {
      navigate('/sign-in');
    }
  }

  return { fetchSensorBillableStatuses, loading, error };
};

export default useFetchSensorBillableStatuses;
